module.exports = __webpack_public_path__ + "media/images/voice01-09f85a79fbce78ca09fa0b05c0c12768.jpg";